var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaveCaption = function SvgSaveCaption(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    style: {
      fill: "transparent"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.712 6.799c.781 0 1.414-.626 1.414-1.399 0-.772-.633-1.398-1.414-1.398-.78 0-1.413.626-1.413 1.398 0 .773.633 1.399 1.413 1.399Z",
    stroke: "#fff",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.81v-.82c0-.485.4-.886.895-.886.853 0 1.202-.597.773-1.328a.88.88 0 0 1 .33-1.208l.815-.461a.791.791 0 0 1 1.074.28l.052.088c.424.732 1.122.732 1.55 0l.052-.089a.791.791 0 0 1 1.075-.28l.815.462a.88.88 0 0 1 .33 1.208c-.43.731-.08 1.328.772 1.328.49 0 .896.396.896.886v.82c0 .485-.4.886-.896.886-.853 0-1.201.597-.772 1.328a.879.879 0 0 1-.33 1.208l-.815.461a.791.791 0 0 1-1.075-.28l-.052-.088c-.424-.732-1.121-.732-1.55 0l-.052.089a.791.791 0 0 1-1.074.28l-.815-.462a.88.88 0 0 1-.33-1.208c.429-.731.08-1.328-.773-1.328A.893.893 0 0 1 1 5.81Z",
    stroke: "#fff",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.5h7A1.5 1.5 0 0 1 21.5 7v13a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 20v-7.5c0-.905-1.5-.905-1.5 0V20a3 3 0 0 0 3 3h13a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-7c-.905 0-.905 1.5 0 1.5Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.571A2.125 2.125 0 0 0 17.071 11c-1.315 0-2.38 1.28-2.38 2.857 0 1.578 1.065 2.857 2.38 2.857.536 0 1.03-.212 1.429-.57m-6.19-4.573A2.125 2.125 0 0 0 10.88 11c-1.314 0-2.38 1.28-2.38 2.857 0 1.578 1.066 2.857 2.38 2.857.537 0 1.031-.212 1.43-.57",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgSaveCaption;